module.exports = __webpack_public_path__ + "img/1500760596.a2783835.jpg";